import Header from './components/Header';
import Hero from './components/Hero';
import Topics from './components/Topics';
import AppEntry from './components/AppEntry';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import MediaCards from './components/MediaCards';
import Carousel from './components/Carousel';
import About from './components/About';
import IndexGrid from './components/IndexGrid';
import Comments from './components/Comments';
import InfoCards from './components/InfoCards';
import Ranking from './components/Ranking';
import Updates from './components/Updates';
import Features from './components/Features';
import Footer from './components/Footer';

export default function Home() {
  return (
    <main className="relative min-h-screen bg-background-50">
      <Header />
      <Hero />
      <Topics />
      <AppEntry />
      <FAQ />
      <Contact />
      <MediaCards />
      <Carousel />
      <About />
      <IndexGrid />
      <Comments />
      <InfoCards />
      <Ranking />
      <Updates />
      <Features />
      <Footer />
    </main>
  );
}